import React, { useContext, useEffect, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button, Container } from "react-bootstrap";
// Componentes
import VistaPersonasAtendidas from "../vistas/VistaPersonasAtendidas";
import FormPersonasAtendidas from "../formularios/FormPersonasAtendidas";
// Contexto
import { ModalContext } from "../../../../context/modalContext";
import { AlertBoxContext } from "../../../../context/alertBoxContext";
// jquery
import $ from "jquery";
// Utils
import { personasAtendidas } from "../../../../contexto";
// Custom spinner
import CustomSpinner from "../../../generic/CustomSpinner";

const PersonasAtendidas = ({ idProvincia, idMision }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Datos sanitario de la misión
  const [datosPersonasAtendidas, setDatosPersonasAtendidas] = useState({});
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);

  useEffect(() => {
    handleGetDatosPersonasAtendidas();
  }, []);

  // Obtiene los datos de las personas atendidas de la obra
  const getDatosPersonasAtendidas = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${idMision}/personasAtendidas`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Edita los datos de una misión de las personas atendidas
  const postDatosPersonasAtendidas = (data) => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/misiones/${idMision}/personasAtendidas`,
      method: "POST",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  // Manejador para obtener los datos de la misión de categoria educativa
  const handleGetDatosPersonasAtendidas = () => {
    setLoading(true);
    getDatosPersonasAtendidas()
      .then((response) => {
        setLoading(false);
        setDatosPersonasAtendidas(processDatosPersonasAtendidas(response.items));
      })
      .catch(() => {
        setLoading(false);
        // props?.ErrorHandling();
      });
  };

  // Manejador para el put de los datos de las personas atendidas de una mision
  const handlePostDatosPersonasAtendidas = (data) => {
    setLoading(true);
    modalSetShow(false);

    Promise.all(
      personasAtendidas.map((tipoPersonasAtendidas) => {
        return postDatosPersonasAtendidas(data[tipoPersonasAtendidas]);
      })
    )
      .then(() => {
        setLoading(false);
        // Volvemos a pedir los datos de las personas atendidas (TODO deberiamos crear función que actualice el estado)
        handleGetDatosPersonasAtendidas();
        addAlert("Exito", "Se han editado las personas atendidas de la obra correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        // props?.ErrorHandling();
      });
  };

  // Manejamos con la siguiente función los datos educativos para poder pintarlos para ello los guardamos en el estado
  const processDatosPersonasAtendidas = (misDatosPersonasAtendidas) => {
    let returnDatosPersonasAtendidas = {};
    // Recorremos y rellenamos con los que devuelve la petición
    for (let tipoDatoPersonaAtendida of misDatosPersonasAtendidas) {
      returnDatosPersonasAtendidas[tipoDatoPersonaAtendida.type] = tipoDatoPersonaAtendida;
    }
    return returnDatosPersonasAtendidas;
  };

  return (
    <div style={{ position: "relative" }}>
      <CustomSpinner animation={"border"} loading={loading} />
      <Accordion defaultActiveKey="1">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              Estructura de la obra
            </Accordion.Toggle>
            <Button
              variant="outline-primary"
              size="sm"
              className="float-right mr-4"
              onClick={() => {
                modalSetShow(true, "80%");
                modalSetTitle("Editar estructura de la obra");
                modalSetContent(<FormPersonasAtendidas defaultValues={datosPersonasAtendidas} submissionHandler={handlePostDatosPersonasAtendidas} />);
              }}
            >
              Editar
            </Button>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className={"bg-light"}>
              <VistaPersonasAtendidas datosPersonasAtendidas={datosPersonasAtendidas} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default PersonasAtendidas;
